
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local';

// Get language from URL or default to 'en'
const getLanguageFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const langFromURL = urlParams.get('lang');
  const supportedLanguages = ['en', 'de', 'it'];
  
  if (langFromURL && supportedLanguages.includes(langFromURL)) {
    return langFromURL;
  }
  
  // Check browser language
  const browserLang = navigator.language.split('-')[0];
  if (supportedLanguages.includes(browserLang)) {
    return browserLang;
  }
  
  return 'en';
};

const currentLanguage = getLanguageFromURL();

i18n
  .use(initReactI18next)
  .init({
    resources: messages,
    lng: currentLanguage,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: false,
    },
  });

export default i18n;
